import React from "react";
import EnvCheckForm from "../components/EnvCheckForm";

const EnvCheck = () => {
    return (
        <>
            <section className="flex justify-center items-center w-full h-screen bg-gray-100">
                <EnvCheckForm />
            </section>
        </>
    );
};

export default EnvCheck;
